(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('arching', {
                parent: 'app',
                url: '/arching',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/arching/arching.html',
                        controller: 'archingController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['arching']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }]
                        }
                    }
                }
            });
    }
})();
